export default __webpack_public_path__ + "static/media/SRC_circle3.6a3e8aed.png";